import { useState } from "react";
import { VehiclePermissionAffectedBooking } from "../types/VehiclePermissions.types";

type PendingPermissionsSave = {
  vehicleId: number;
  vehicleName: string;
  formData: FormData;
} | null;

type UseAffectedPermissionsConfirmArgs = {
  updateFleet: (args: { id: number; formData: FormData }) => Promise<unknown>;
  refetchRemoteFleetData: () => void;
};

export const useAffectedPermissionsConfirm = ({
  updateFleet,
  refetchRemoteFleetData
}: UseAffectedPermissionsConfirmArgs) => {
  const [affectedBookingsForDialog, setAffectedBookingsForDialog] = useState<
    VehiclePermissionAffectedBooking[]
  >([]);
  const [showAffectedDialog, setShowAffectedDialog] = useState(false);
  const [pendingPermissionsSave, setPendingPermissionsSave] =
    useState<PendingPermissionsSave>(null);

  const startConfirmFlow = (params: {
    vehicleId: number;
    vehicleName: string;
    formData: FormData;
    affectedBookings: VehiclePermissionAffectedBooking[];
  }) => {
    setAffectedBookingsForDialog(params.affectedBookings);
    setPendingPermissionsSave({
      vehicleId: params.vehicleId,
      vehicleName: params.vehicleName,
      formData: params.formData
    });
    setShowAffectedDialog(true);
  };

  const applyPermissionsSave = async () => {
    if (!pendingPermissionsSave) return;
    const { vehicleId, formData } = pendingPermissionsSave;
    await updateFleet({ id: vehicleId, formData });
    refetchRemoteFleetData();
  };

  const clearConfirmFlow = () => {
    setShowAffectedDialog(false);
    setPendingPermissionsSave(null);
    setAffectedBookingsForDialog([]);
  };

  return {
    // state
    showAffectedDialog,
    affectedBookingsForDialog,
    pendingPermissionsSave,
    // actions
    startConfirmFlow,
    applyPermissionsSave,
    clearConfirmFlow
  };
};
